import React from "react";

import { Flex, IconTick,Text } from "@catchoftheday/cg-components";

export type NotificationToastContentProps = {
  message: string;
};

export const NotificationToastContent = ({
  message,
}: NotificationToastContentProps) => {
  return (
    <Flex color="primary" alignItems="center">
      <IconTick mr="10px" width="20px" aria-hidden="true" />
      <Text mb="0" mt="0" fontWeight="bold">
        {message}
      </Text>
    </Flex>
  );
};
